import { render, staticRenderFns } from "./confirm-order.vue?vue&type=template&id=289d05d5&scoped=true&"
import script from "./confirm-order.vue?vue&type=script&lang=js&"
export * from "./confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./confirm-order.vue?vue&type=style&index=0&id=289d05d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d05d5",
  null
  
)

export default component.exports